<template>
  <div class="resume-playback-tip" v-if="visible" @click.stop>
    <div class="tip-content">
      <span class="tip-text">
        从<span class="time-highlight">{{ formatTime(resumeTime) }}</span>继续播放
      </span>
      <button class="resume-btn button" @click="handleResume">继续播放</button>
    </div>
  </div>
</template>

<script>
import { formatDuration } from '@/common/js/util';

export default {
  name: 'ResumePlaybackTip',
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    resumeTime: {
      type: Number,
      default: 0,
    },
  },
  methods: {
    formatTime(seconds) {
      const time =  formatDuration(seconds).split(':');
      if (time.length === 2) {
        return `${time[0]}分${time[1]}秒`;
      }
      return `${time[0]}时${time[1]}分${time[2]}秒`;
    },
    handleResume() {
      this.$emit('resume', this.resumeTime);
    },
  },
};
</script>

<style scoped>
.resume-playback-tip {
  /* position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 5;
  pointer-events: auto; */
}

.tip-content {
  display: flex;
  align-items: center;
  gap: 16px;
  background: rgba(0, 0, 0, 0.7);
  border-radius: 14px;
  padding: 0 16px;
  height: 60px;
  /* backdrop-filter: blur(8px); */
}

.tip-text {
  color: #fff;
  font-size: 14px;
  white-space: nowrap;
}

.time-highlight {
  color: #E60012;
  font-weight: 600;
}

.resume-btn {
  background: #E60012;
  color: #fff;
  border: none;
  border-radius: 24px;
  font-size: 12px;
  transition: background 0.2s ease;
  white-space: nowrap;
  width: 78px;
  height: 28px;
}

.resume-btn:hover {
  background: #cc0010;
}
</style>

